module.exports = __webpack_public_path__ + "static/media/freeCarMaintainence.0731f1a7.svg";